import RegisterNetWeights from './RegisterNetWeights';

export default RegisterNetWeights;
